import { useEffect, useState } from 'react';

import { API_CONFIG_SITE } from './EsConstants';
import { esRead } from './EsFetch';

/*
 * The site's public settings (the home page trailer), asked once per page load and shared, as
 * the theme is. null until the server answers, so a caller can hold its slot rather than draw
 * a default that the answer then replaces. A failed read settles on a blank video: the page
 * paints without a trailer rather than waiting on one.
 */
let gAsked = null;

export const esSiteConfig = () => {
    if ( !gAsked ) {
        gAsked = esRead( API_CONFIG_SITE )
            .then( ( pBody ) => ( { homeVideoId: pBody?.homeVideoId || '', homeVideoSize: pBody?.homeVideoSize || '' } ) )
            .catch( () => ( { homeVideoId: '', homeVideoSize: '' } ) );
    }
    return gAsked;
};

/** After a save, and in tests: forget the answer. */
export const esSiteConfigReset = () => { gAsked = null; };

export const useEsSiteConfig = () => {
    const [ aConfig, setConfig ] = useState( null );

    useEffect( () => {
        let aLive = true;
        void esSiteConfig().then( ( pConfig ) => { if ( aLive ) setConfig( pConfig ); } );
        return () => { aLive = false; };
    }, [] );

    return aConfig;
};
